export const getarkaplankontrol=state => state.arkaplankontrol;
export const gethaberkontrol=state => state.haberkontrol;
export const getbaskankontrol=state => state.baskankontrol;
export const getArkaplan=state => state.Arkaplan;
export const getHaberler=state => state.Haberler;
export const getBaskan=state => state.Baskan;
export const getApi=state => state.apikey1;